/**
 * @fileoverview gRPC-Web generated client stub for reportpb
 * @enhanceable
 * @public
 */

// Code generated by protoc-gen-grpc-web. DO NOT EDIT.
// versions:
// 	protoc-gen-grpc-web v2.0.2
// 	protoc              v0.0.0
// source: reportpb/segregationpriority.proto


/* eslint-disable */
// @ts-nocheck



const grpc = {};
grpc.web = require('grpc-web');


var google_type_date_pb = require('../google/type/date_pb.js')
const proto = {};
proto.reportpb = require('./segregationpriority_pb.js');

/**
 * @param {string} hostname
 * @param {?Object} credentials
 * @param {?grpc.web.ClientOptions} options
 * @constructor
 * @struct
 * @final
 */
proto.reportpb.SegregationPriorityServiceClient =
    function(hostname, credentials, options) {
  if (!options) options = {};
  options.format = 'text';

  /**
   * @private @const {!grpc.web.GrpcWebClientBase} The client
   */
  this.client_ = new grpc.web.GrpcWebClientBase(options);

  /**
   * @private @const {string} The hostname
   */
  this.hostname_ = hostname.replace(/\/+$/, '');

};


/**
 * @param {string} hostname
 * @param {?Object} credentials
 * @param {?grpc.web.ClientOptions} options
 * @constructor
 * @struct
 * @final
 */
proto.reportpb.SegregationPriorityServicePromiseClient =
    function(hostname, credentials, options) {
  if (!options) options = {};
  options.format = 'text';

  /**
   * @private @const {!grpc.web.GrpcWebClientBase} The client
   */
  this.client_ = new grpc.web.GrpcWebClientBase(options);

  /**
   * @private @const {string} The hostname
   */
  this.hostname_ = hostname.replace(/\/+$/, '');

};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.reportpb.CreateSegregationPriorityRequest,
 *   !proto.reportpb.CreateSegregationPriorityResponse>}
 */
const methodDescriptor_SegregationPriorityService_CreateSegregationPriority = new grpc.web.MethodDescriptor(
  '/reportpb.SegregationPriorityService/CreateSegregationPriority',
  grpc.web.MethodType.UNARY,
  proto.reportpb.CreateSegregationPriorityRequest,
  proto.reportpb.CreateSegregationPriorityResponse,
  /**
   * @param {!proto.reportpb.CreateSegregationPriorityRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.reportpb.CreateSegregationPriorityResponse.deserializeBinary
);


/**
 * @param {!proto.reportpb.CreateSegregationPriorityRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.reportpb.CreateSegregationPriorityResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.reportpb.CreateSegregationPriorityResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.reportpb.SegregationPriorityServiceClient.prototype.createSegregationPriority =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/reportpb.SegregationPriorityService/CreateSegregationPriority',
      request,
      metadata || {},
      methodDescriptor_SegregationPriorityService_CreateSegregationPriority,
      callback);
};


/**
 * @param {!proto.reportpb.CreateSegregationPriorityRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.reportpb.CreateSegregationPriorityResponse>}
 *     Promise that resolves to the response
 */
proto.reportpb.SegregationPriorityServicePromiseClient.prototype.createSegregationPriority =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/reportpb.SegregationPriorityService/CreateSegregationPriority',
      request,
      metadata || {},
      methodDescriptor_SegregationPriorityService_CreateSegregationPriority);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.reportpb.UpdateSegregationPriorityRequest,
 *   !proto.reportpb.UpdateSegregationPriorityResponse>}
 */
const methodDescriptor_SegregationPriorityService_UpdateSegregationPriority = new grpc.web.MethodDescriptor(
  '/reportpb.SegregationPriorityService/UpdateSegregationPriority',
  grpc.web.MethodType.UNARY,
  proto.reportpb.UpdateSegregationPriorityRequest,
  proto.reportpb.UpdateSegregationPriorityResponse,
  /**
   * @param {!proto.reportpb.UpdateSegregationPriorityRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.reportpb.UpdateSegregationPriorityResponse.deserializeBinary
);


/**
 * @param {!proto.reportpb.UpdateSegregationPriorityRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.reportpb.UpdateSegregationPriorityResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.reportpb.UpdateSegregationPriorityResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.reportpb.SegregationPriorityServiceClient.prototype.updateSegregationPriority =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/reportpb.SegregationPriorityService/UpdateSegregationPriority',
      request,
      metadata || {},
      methodDescriptor_SegregationPriorityService_UpdateSegregationPriority,
      callback);
};


/**
 * @param {!proto.reportpb.UpdateSegregationPriorityRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.reportpb.UpdateSegregationPriorityResponse>}
 *     Promise that resolves to the response
 */
proto.reportpb.SegregationPriorityServicePromiseClient.prototype.updateSegregationPriority =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/reportpb.SegregationPriorityService/UpdateSegregationPriority',
      request,
      metadata || {},
      methodDescriptor_SegregationPriorityService_UpdateSegregationPriority);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.reportpb.ReadSegregationPriorityRequest,
 *   !proto.reportpb.ReadSegregationPriorityResponse>}
 */
const methodDescriptor_SegregationPriorityService_ReadSegregationPriority = new grpc.web.MethodDescriptor(
  '/reportpb.SegregationPriorityService/ReadSegregationPriority',
  grpc.web.MethodType.UNARY,
  proto.reportpb.ReadSegregationPriorityRequest,
  proto.reportpb.ReadSegregationPriorityResponse,
  /**
   * @param {!proto.reportpb.ReadSegregationPriorityRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.reportpb.ReadSegregationPriorityResponse.deserializeBinary
);


/**
 * @param {!proto.reportpb.ReadSegregationPriorityRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.reportpb.ReadSegregationPriorityResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.reportpb.ReadSegregationPriorityResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.reportpb.SegregationPriorityServiceClient.prototype.readSegregationPriority =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/reportpb.SegregationPriorityService/ReadSegregationPriority',
      request,
      metadata || {},
      methodDescriptor_SegregationPriorityService_ReadSegregationPriority,
      callback);
};


/**
 * @param {!proto.reportpb.ReadSegregationPriorityRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.reportpb.ReadSegregationPriorityResponse>}
 *     Promise that resolves to the response
 */
proto.reportpb.SegregationPriorityServicePromiseClient.prototype.readSegregationPriority =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/reportpb.SegregationPriorityService/ReadSegregationPriority',
      request,
      metadata || {},
      methodDescriptor_SegregationPriorityService_ReadSegregationPriority);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.reportpb.DeleteSegregationPriorityRequest,
 *   !proto.reportpb.DeleteSegregationPriorityResponse>}
 */
const methodDescriptor_SegregationPriorityService_DeleteSegregationPriority = new grpc.web.MethodDescriptor(
  '/reportpb.SegregationPriorityService/DeleteSegregationPriority',
  grpc.web.MethodType.UNARY,
  proto.reportpb.DeleteSegregationPriorityRequest,
  proto.reportpb.DeleteSegregationPriorityResponse,
  /**
   * @param {!proto.reportpb.DeleteSegregationPriorityRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.reportpb.DeleteSegregationPriorityResponse.deserializeBinary
);


/**
 * @param {!proto.reportpb.DeleteSegregationPriorityRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.reportpb.DeleteSegregationPriorityResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.reportpb.DeleteSegregationPriorityResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.reportpb.SegregationPriorityServiceClient.prototype.deleteSegregationPriority =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/reportpb.SegregationPriorityService/DeleteSegregationPriority',
      request,
      metadata || {},
      methodDescriptor_SegregationPriorityService_DeleteSegregationPriority,
      callback);
};


/**
 * @param {!proto.reportpb.DeleteSegregationPriorityRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.reportpb.DeleteSegregationPriorityResponse>}
 *     Promise that resolves to the response
 */
proto.reportpb.SegregationPriorityServicePromiseClient.prototype.deleteSegregationPriority =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/reportpb.SegregationPriorityService/DeleteSegregationPriority',
      request,
      metadata || {},
      methodDescriptor_SegregationPriorityService_DeleteSegregationPriority);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.reportpb.ListSegregationPriorityRequest,
 *   !proto.reportpb.ListSegregationPriorityResponse>}
 */
const methodDescriptor_SegregationPriorityService_ListSegregationPriority = new grpc.web.MethodDescriptor(
  '/reportpb.SegregationPriorityService/ListSegregationPriority',
  grpc.web.MethodType.UNARY,
  proto.reportpb.ListSegregationPriorityRequest,
  proto.reportpb.ListSegregationPriorityResponse,
  /**
   * @param {!proto.reportpb.ListSegregationPriorityRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.reportpb.ListSegregationPriorityResponse.deserializeBinary
);


/**
 * @param {!proto.reportpb.ListSegregationPriorityRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.reportpb.ListSegregationPriorityResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.reportpb.ListSegregationPriorityResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.reportpb.SegregationPriorityServiceClient.prototype.listSegregationPriority =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/reportpb.SegregationPriorityService/ListSegregationPriority',
      request,
      metadata || {},
      methodDescriptor_SegregationPriorityService_ListSegregationPriority,
      callback);
};


/**
 * @param {!proto.reportpb.ListSegregationPriorityRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.reportpb.ListSegregationPriorityResponse>}
 *     Promise that resolves to the response
 */
proto.reportpb.SegregationPriorityServicePromiseClient.prototype.listSegregationPriority =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/reportpb.SegregationPriorityService/ListSegregationPriority',
      request,
      metadata || {},
      methodDescriptor_SegregationPriorityService_ListSegregationPriority);
};


module.exports = proto.reportpb;

